export default function formatMoney(money) {
  if (!money) return null;
  return money?.toLocaleString() || 0;
}
